import Vue from "vue"
import Router from "vue-router"
import store from "@/store"
import publicRoutes from "@/router/public.js"
import privateRoutes from "@/router/private.js"

Vue.use(Router)

const router = new Router({
    mode: "history",
    routes: publicRoutes.concat(privateRoutes)
})

router.beforeEach((to, from, next) => {
    const isAuthenticated = store.getters.isAuthenticated
    const onlyLoggedOut = to.matched.some(record => record.meta.onlyLoggedOut)
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    if (requiresAuth) {
        if (!isAuthenticated){
            next({
                path: "/login"
            });
        }else{
            next();
        }
    }else if (onlyLoggedOut)  {
        if (isAuthenticated){
            next({
                path: "/datasets"
            });
        }else{
            next();
        }
    }else{
        next();
    }
});

export default router;